import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';

import type {FieldCreateInput} from 'nutshell-graphql-types';

import type {FormFieldRowForDuplicateHelpers} from '../../../../types';

import {AddFieldCard} from './add-field-card';

import styles from './add-card.module.css';

type Props = {
    formId: string;
    fields: FormFieldRowForDuplicateHelpers[];
    formSchema: any;
    fetchFormSchema: () => void;
    onAddCardClick: () => void;
    onCreateNewField: (arg1: FieldCreateInput) => any;
};

export function AddField(props: Props) {
    const [isAddingField, setIsAddingField] = React.useState<boolean>(false);

    const addFieldRef = React.useRef(null);

    React.useEffect(() => {
        if (addFieldRef && addFieldRef.current) {
            // @ts-expect-error
            addFieldRef.current.scrollIntoView();
        }
    }, [isAddingField]);

    const onClose = () => setIsAddingField(false);

    return (
        <div>
            {isAddingField ? (
                <div
                    ref={(ref) => {
                        // @ts-expect-error
                        addFieldRef.current = ref;
                    }}
                    className={styles['add-card-container']}
                >
                    <AddFieldCard
                        formId={props.formId}
                        fields={props.fields}
                        onSelectInputField={(input) => {
                            props.onCreateNewField(input);
                            onClose();
                        }}
                        onClose={onClose}
                        formSchema={props.formSchema}
                        fetchFormSchema={props.fetchFormSchema}
                    />
                </div>
            ) : (
                <div className={styles['new-item-container']}>
                    <EmptyAddCard
                        text='Add a field'
                        onClick={() => {
                            props.onAddCardClick();
                            setIsAddingField(true);
                        }}
                        background='off-white'
                        size='small'
                        withoutIcon={true}
                    />
                </div>
            )}
        </div>
    );
}
